import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const avaliaIntranetPlugin = createPlugin({
  id: 'avalia-intranet',
  routes: {
    root: rootRouteRef,
  },
});

export const AvaliaIntranetHomePage = avaliaIntranetPlugin.provide(
  createRoutableExtension({
    name: 'AvaliaIntranetHomePage',
    component: () =>
      import('./pages/HomePage/HomePage').then(m => m.HomePage),
    mountPoint: rootRouteRef,
  }),
);
